import PropTypes from "prop-types";
import * as React from "react";
import { t } from "helpers/localization";
import { HiddenStatisticsIcon } from "@wg/wows-react-uikit";
import { DEFAULT_ERROR } from "helpers/formatting";

import { ClanIsDisbandedTooltip, ClanMembersInfoMissingTooltip, MemberInfoMissingTooltip } from "tooltips";


const propTypes = {
  value: PropTypes.string.isRequired,

  isHidden: PropTypes.bool,
  isClan: PropTypes.bool,
  clanDisbanded: PropTypes.bool,
  disableTooltip: PropTypes.bool,
  className: PropTypes.string
};

class StatisticsValue extends React.PureComponent {

  render() {
    if (this.props.isHidden) {
      return <HiddenStatisticsIcon isClan={this.props.isClan} disableTooltip={this.props.disableTooltip} t={t} />;
    } else {
      const needTooltip = this.props.value === DEFAULT_ERROR && !this.props.disableTooltip;

      let dataTip = null;
      let tooltipId = null;
      if (needTooltip) {
        dataTip = true;
        tooltipId = this.props.isClan ? this.props.clanDisbanded ? ClanIsDisbandedTooltip.id : ClanMembersInfoMissingTooltip.id : MemberInfoMissingTooltip.id;
      }

      return <div className={this.props.className}>
                    <div data-tip={dataTip} data-for={tooltipId}>
                        {this.props.value}
                    </div>
                </div>;
    }
  }
}

StatisticsValue.propTypes = propTypes;

export default StatisticsValue;